import { EventModel } from '@bryntum/schedulerpro';
import {
  ResourceManagementEvents,
  SchedulerEventType,
} from '../../event-types';

export class AllocationEventModel extends EventModel {
  static get fields() {
    return [
      { name: 'type', type: 'string' },
      { name: 'allocatedMinutes', type: 'number' },
      { name: 'availableMinutes', type: 'number' },
      { name: 'minutes', type: 'number' },
      { name: 'totalMinutes', type: 'number' },
      { name: 'phaseName', type: 'string' },
      { name: 'groupKey', type: 'string' },
      { name: 'rowIndex', type: 'number' },
      { name: 'activePhase', type: 'boolean' },
      { name: 'top', type: 'number' },
      { name: 'height', type: 'number' },
      { name: 'overAllocations', type: 'object' },
      { name: 'overAllocationsForUI', type: 'object' },
      { name: 'projectId', type: 'number' },
      { name: 'userId', type: 'number' },
      { name: 'active', type: 'boolean' },
      { name: 'splitModeActive', type: 'boolean' },
      { name: 'showInDetail', type: 'boolean' },
      { name: 'teamId', type: 'number' },
      { name: 'roleId', type: 'number' },
      { name: 'referenceTeamId', type: 'number' },
      { name: 'medium', type: 'string' },
      { name: 'usersAllocatedMinutes', type: 'object' },
      { name: 'teamsAllocatedMinutes', type: 'object' },
      { name: 'allocatedMinutes', type: 'object' },
      { name: 'capacity', type: 'number' },
      { name: 'roleId', type: 'number' },
      { name: 'userCount', type: 'number' },
      { name: 'minutesPercentage', type: 'number' },
      { name: 'readOnly', type: 'boolean' },
      { name: 'forViewPreset', type: 'string' },
      { name: 'timeOff', type: 'object' },
      { name: 'companyName', type: 'string' },
      { name: 'companyId', type: 'number' },
      { name: 'isIgnored', type: 'boolean' },
      { name: 'teamMemberCapacityFte', type: 'number' },
      { name: 'partnerCapacityFte', type: 'number' },
      { name: 'timeOffCapacityFte', type: 'number' },
      { name: 'holidayCapacityFte', type: 'number' },
      { name: 'capacityAllocationDiffFte', type: 'number' },
      { name: 'allocationInProjectFte', type: 'number' },
      { name: 'holiday', type: 'object' },
      { name: 'totalAllocationFte', type: 'number' },
    ];
  }

  minutes: number;

  constructor(config: Partial<ResourceManagementEvents>) {
    super(config);
    this.minutes =
      config.type === SchedulerEventType.Allocation ? config.minutes ?? 0 : 0;
  }
}
